import { Component, OnDestroy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { Router } from '@angular/router';
import { ResourceUserService } from '../../service/settings/resource-user.service';
import { MatTableDataSource } from '@angular/material/table';
import { ResourceUser } from '../../domain/model/resource-user';
import { takeWhile } from 'rxjs/operators';
import { SettingsResourceUserDetailComponent } from '../settings-resource-user-detail/settings-resource-user-detail.component';

@Component({
    selector: 'redispatch-settings-resource-user',
    templateUrl: './settings-resource-user-page.component.html',
    styleUrls: [
        './settings-resource-user-page.component.scss',
    ],
    standalone: false,
})
export class SettingsResourceUserPageComponent implements OnInit, OnDestroy {
    private componentDestroyed = false;
    public userList: MatTableDataSource<ResourceUser> = new MatTableDataSource<ResourceUser>();

    public columnsToDisplay = [
        'username',
        'enabled',
        'allowRead',
        'allowWrite',
    ];

    private userService = inject(ResourceUserService);
    private router = inject(Router);
    public westnetzSidenavService = inject(WestnetzSidenavService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        this.loadUsers();

        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.loadUsers();
            });
    }

    ngOnDestroy() {
        this.componentDestroyed = true;
    }

    createUser() {
        this.router.navigate([], {
            queryParams: { username: '' },
            queryParamsHandling: 'merge',
            skipLocationChange: true,
        });
        this.westnetzSidenavService.openRightnav(SettingsResourceUserDetailComponent);
    }

    openUser(user) {
        this.router.navigate([], {
            queryParams: { username: user.username },
            queryParamsHandling: 'merge',
            skipLocationChange: true,
        });
        this.westnetzSidenavService.openRightnav(SettingsResourceUserDetailComponent);
    }

    private loadUsers() {
        this.userService.getUsers().subscribe(users => {
            this.userList.data = users;
            this.changeDetectorRef.markForCheck();
        });
    }
}
